module.exports = __webpack_public_path__ + "img/VgrapherForm.7059aaa8.jpg";